// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1hge4","col":"CardReaderDesc_col__3XRNL","label":"CardReaderDesc_label__3o23o"};